import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useTimer } from 'react-timer-hook'

type CountdownProps = {
  title: string
  expiryTimestamp: Date
}

export const Countdown = ({ title, expiryTimestamp }: CountdownProps) => {
  const { t } = useTranslation()

  const { days, hours, minutes } = useTimer({
    expiryTimestamp: expiryTimestamp,
    onExpire: () => console.warn('Expired'),
    autoStart: true,
  })

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography color="white" fontWeight="bold">
        {title}
      </Typography>
      <Stack
        justifyContent="center"
        alignItems="center"
        direction="row"
        spacing={0.5}
      >
        <Stack alignItems="center" justifyContent="center">
          <Typography variant="caption" color="white">
            {t('day')}
          </Typography>
          <Box
            sx={{ py: 1, width: '36px', background: '#fff', borderRadius: '8px' }}
          >
            <Typography textAlign="center" fontWeight="bold" variant="body2">
              {days}
            </Typography>
          </Box>
        </Stack>
        <Stack alignItems="center" justifyContent="center">
          <Typography variant="caption" color="white">
            {t('hour')}
          </Typography>
          <Box
            sx={{ py: 1, width: '36px', background: '#fff', borderRadius: '8px' }}
          >
            <Typography textAlign="center" fontWeight="bold" variant="body2">
              {hours}
            </Typography>
          </Box>
        </Stack>
        <Stack alignItems="center" justifyContent="center">
          <Typography variant="caption" color="white">
            {t('minuteShort')}
          </Typography>
          <Box
            sx={{ py: 1, width: '36px', background: '#fff', borderRadius: '8px' }}
          >
            <Typography textAlign="center" fontWeight="bold" variant="body2">
              {minutes}
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  )
}
